(function() {
  'use strict';

  function initDistrictSelector() {
    const districtSelectors = document.querySelectorAll('.district-selector');
    
    if (!districtSelectors.length) return;

    districtSelectors.forEach(selector => {
      const trigger = selector.querySelector('.district-select-trigger');
      const dropdown = selector.querySelector('.district-select-dropdown');
      const selectText = selector.querySelector('.district-select-text');
      const optionItems = selector.querySelectorAll('.district-option-item');

      if (!trigger || !dropdown) return;

      // Toggle dropdown on selector click (anywhere on the selector)
      selector.addEventListener('click', function(e) {
        // Don't toggle if clicking inside the dropdown
        if (dropdown.contains(e.target)) {
          return;
        }
        selector.classList.toggle('active');
      });

      // Handle option selection (like a select)
      optionItems.forEach(optionItem => {
        optionItem.addEventListener('click', function(e) {
          e.stopPropagation();
          
          const optionLabel = optionItem.querySelector('.district-option-label');
          const selectedValue = optionLabel.getAttribute('data-value') || optionLabel.textContent.trim();
          
          // Get the hidden input field for district
          const districtInput = selector.closest('.field').querySelector('input[type="hidden"]');
          
          // Remove active class from all options
          optionItems.forEach(item => {
            item.classList.remove('active');
          });
          
          // Add active class to clicked option
          optionItem.classList.add('active');
          
          // Update display text
          selectText.textContent = selectedValue;
          
          // Update hidden input value for form submission
          if (districtInput) {
            districtInput.value = selectedValue;
          }
          
          // Close dropdown after selection
          selector.classList.remove('active');
        });
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!selector.contains(e.target)) {
          selector.classList.remove('active');
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDistrictSelector);
  } else {
    initDistrictSelector();
  }
})();

